declare namespace $ {

	export class $exso_logo extends $mol_image {
		uri( ): string
	}
	
}

//# sourceMappingURL=logo.view.tree.d.ts.map